import styled from "styled-components";
import { MediaQueries } from "src/constants";
import { Box } from "src/components/Box";

export const AdditionalInfoContainerEl = styled.div`
  ${MediaQueries.screen.medium.minWidth} {
    margin-bottom: ${(p) => p.theme.dimension.spacing.xl}px;
  }
`;

export const BoldDividerEl = styled.div`
  ${MediaQueries.screen.medium.minWidth} {
    border-bottom: 3px solid ${(props) => props.theme.colors.borders.appBar};
    margin-bottom: ${(p) => p.theme.dimension.spacing.xl}px;
  }
`;

export const BoxRowEl = styled(Box)`
  ${MediaQueries.screen.medium.minWidth} {
    width: 840px;
    display: flex;
    align-items: baseline;

    > div {
      flex: 1;

      :first-child {
        margin-right: ${(p) => p.theme.dimension.spacing.xl}px;
      }

      :only-child {
        flex: 0.5;
      }
    }

    padding-bottom: ${(p) => p.theme.dimension.spacing.s}px;
  }
`;

export const CheckboxContainerEl = styled(Box)`
  label {
    padding: 0;
  }
  margin-bottom: ${(p) => p.theme.dimension.spacing.xl}px;
`;

export const DividerEl = styled.div`
  ${MediaQueries.screen.medium.minWidth} {
    border-bottom: 1px solid ${(props) => props.theme.colors.borders.appBar};
    margin-bottom: ${(p) => p.theme.dimension.spacing.xl}px;
  }
`;

export const GridContainerEl = styled(Box)`
  ${MediaQueries.screen.medium.minWidth} {
    max-width: 840px;
    padding-bottom: ${(p) => p.theme.dimension.spacing.s}px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr auto;
    > div {
      width: 408px;
      :first-child {
        margin-right: ${(p) => p.theme.dimension.spacing.xl}px;
      }
    }
  }
`;

export const LabelEl = styled.label`
  font-family: ${(props) => props.theme.text.fontFamily.demi};
  font-size: ${(props) =>
    props.theme.text.size[props.theme.components.input.labelFontSize]};
`;

export const SecondInputContainerEl = styled(Box)`
  ${MediaQueries.screen.medium.minWidth} {
    align-self: flex-end;
    > div {
      margin-top: 30px;
    }
  }
`;

export const TextFieldContainerEl = styled.div`
  margin-top: ${(p) => p.theme.dimension.spacing.s}px;
  margin-bottom: ${(p) => p.theme.dimension.spacing.l}px;
  textarea {
    font-family: Poppins-Regular;
    border-color: ${(props) => props.theme.colors.borders.active};
    :focus,
    :hover,
    :active {
      border-color: ${(props) => props.theme.colors.borders.active};
      background-color: initial;
    }
  }
`;

export const EntityTypeContainerEl = styled.div`
  margin-bottom: ${(p) => p.theme.dimension.spacing.l}px;
  ${MediaQueries.screen.medium.minWidth} {
    margin-bottom: ${(p) => p.theme.dimension.spacing.xl}px;
  }
`;

export const NpwpInputContainerEl = styled(Box)`
  ${MediaQueries.screen.medium.minWidth} {
    margin-bottom: ${(p) => p.theme.dimension.spacing.xl}px;
  }
`;
